const invoice = {
    getlist: 'invoice/getlist',
    add: 'invoice/add',
    update: 'invoice/update',
    remove: 'invoice/remove',
    get: 'salary/get',
    getall: 'invoice/getall',
    clearcache: 'invoice/clear-cache',
    refresh: 'invoice/refresh',
    confirm:'invoice/confirm',
}
export default invoice
